export default __webpack_public_path__ + "static/media/logo-abogados-ah.79a137ee.png";